"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentFunctionAnalysisResultSerializedSchema = exports.ComponentResourceDataSchema = exports.ComponentFunctionDataSchema = void 0;
const zod_1 = require("zod");
const AnalysisType_1 = require("./AnalysisType");
const IComponentFunction_1 = require("../FunctionalModels/IComponentFunction");
const IComponentFunctionAssignment_1 = require("../FunctionalModels/IComponentFunctionAssignment");
const IComponentResource_1 = require("../FunctionalModels/IComponentResource");
const IInsightError_1 = require("../IInsightError");
exports.ComponentFunctionDataSchema = zod_1.z.object({
    functionId: zod_1.z.string(),
    definition: zod_1.z.lazy(() => IComponentFunction_1.IComponentFunctionSchema),
    assignment: zod_1.z.lazy(() => IComponentFunctionAssignment_1.IComponentFunctionAssignmentSchema).nullable(),
    isActive: zod_1.z.boolean(),
    insights: zod_1.z.lazy(() => IInsightError_1.IInsightErrorSchema).array(),
});
exports.ComponentResourceDataSchema = zod_1.z.object({
    resourceId: zod_1.z.string(),
    definition: zod_1.z.lazy(() => IComponentResource_1.IComponentResourceSchema),
    consumption: zod_1.z.lazy(() => IComponentResource_1.ComponentResourceFunctionConsumptionSchema).nullable(),
    insights: zod_1.z.lazy(() => IInsightError_1.IInsightErrorSchema).array(),
});
exports.ComponentFunctionAnalysisResultSerializedSchema = zod_1.z.object({
    type: zod_1.z.literal(AnalysisType_1.AnalysisType.ComponentFunction),
    result: zod_1.z.object({
        moduleName: zod_1.z.string(),
        circuitStateId: zod_1.z.string(),
        functions: zod_1.z.record(zod_1.z.string(), zod_1.z.lazy(() => exports.ComponentFunctionDataSchema)),
        resources: zod_1.z.record(zod_1.z.string(), zod_1.z.lazy(() => exports.ComponentResourceDataSchema)),
    }),
});
//# sourceMappingURL=ComponentFunctionAnalysisResult.js.map